import { render, staticRenderFns } from "./blankpage.vue?vue&type=template&id=614fe270&"
import script from "./blankpage.vue?vue&type=script&lang=js&"
export * from "./blankpage.vue?vue&type=script&lang=js&"
import style0 from "./blankpage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports